/* @flow */

import {createAction} from 'redux-act';

import type {
    EngagementSalesReportDataRequestedAction,
    EngagementSalesListRequestedAction,
} from './types';

/*
 * Action creators
 */
export const requestReportData: (
    payload: $PropertyType<EngagementSalesReportDataRequestedAction, 'payload'>
) => EngagementSalesReportDataRequestedAction = createAction(
    'ENGAGEMENT_SALES_REPORT_DATA_REQUESTED'
);
export const requestListData: (
    payload: $PropertyType<EngagementSalesListRequestedAction, 'payload'>
) => EngagementSalesListRequestedAction = createAction('ENGAGEMENT_SALES_LIST_DATA_REQUESTED');
export const updateReportChartData = createAction('ENGAGEMENT_SALES_REPORT_CHART_DATA_UPDATED');
export const updateReportMaps = createAction('ENGAGEMENT_SALES_REPORT_MAPS_UPDATED');
export const failReportChartData = createAction('ENGAGEMENT_SALES_REPORT_CHART_DATA_FAILED');

// List actions
export const updateListData = createAction('ENGAGEMENT_SALES_LIST_DATA_UPDATED');
export const updateListSummaryData = createAction('ENGAGEMENT_SALES_LIST_SUMMARY_DATA_UPDATED');
export const failListData = createAction('ENGAGEMENT_SALES_LIST_DATA_FAILED');
